// extracted by mini-css-extract-plugin
export default {"container":"WrVXR","image":"kCxra"};